<!-- eslint-disable vue/no-v-html -->+
<!-- The HTML is generated locally -->
<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2022. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->
<template>
  <NerveDialog
    id="iiotNotificationDialog"
    v-model="dialogState"
    scrollable
    persistent
    max-width="500"
    data-cy="iiotNotificationDialog"
    @keydown.enter="confirm()"
  >
    <v-card
      class="backgroundImage notification-dialog d-flex flex-column"
      :style="{ backgroundImage: 'url(' + utilsStore.notificationDialogParams.backgroundImage + ')' }"
    >
      <v-card-title id="iiotNotificationDialogTitle" data-cy="iiotNotificationDialogTitle">
        <div>
          <span class="pl-1 pr-1 introduction">
            {{ utilsStore.notificationDialogParams.title }}
          </span>
        </div>
      </v-card-title>
      <v-card-text
        v-if="utilsStore.notificationDialogParams.textMessageWithLinks"
        id="iiotNotificationDialogSubtitle"
        class="flex-grow-1 text-center text-grey-darken-1"
        data-cy="iiotNotificationDialogSubtitle"
      >
        <mark class="pl-1 pr-1 introduction">
          <span class="ma-2" v-html="utilsStore.notificationDialogParams.textMessageWithLinks" />
        </mark>
      </v-card-text>
      <v-card-text v-else class="flex-grow-1 text-center text-grey-darken-1">
        {{ utilsStore.notificationDialogParams.subTitle }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <NerveButton
          id="iiotNotificationDialogButtonOk"
          :text="$t('errorDialog.okBtn')"
          type-of-btn="action"
          size="normal"
          class="my-0"
          data-cy="iiotNotificationDialogButtonOk"
          autofocus
          @click-event="confirm()"
        />
      </v-card-actions>
    </v-card>
  </NerveDialog>
</template>

<script setup>
import { computed } from 'vue';
import { NerveButton, NerveDialog } from '@nerve/ui-components';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';

/*
  Stores
*/
const utilsStore = useUtilsStore();

/*
  Computed
*/
const dialogState = computed({
  get() {
    return utilsStore.notificationDialog;
  },
  set() {
    close();
  },
});

/*
  Methods
*/
const confirm = async () => {
  if (utilsStore.notificationDialogParams.cancelCallback) {
    await utilsStore.notificationDialogParams.cancelCallback();
  }
  utilsStore.closeNotificationDialog();
};

const close = () => {
  utilsStore.closeNotificationDialog();
};
</script>

<style scoped>
.backgroundImage {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.notification-dialog {
  max-height: 460px !important;
  min-height: 320px !important;
}

.introduction {
  background-color: #ffffff;
  border-radius: 6px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  opacity: 0.8;
  line-height: 1.3em;
}
</style>
